import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CanvasToolboxStateService {
  private readonly _openToolboxId = signal<string | null>(null);
  private readonly _scrollTrigger = signal<number>(0);

  public readonly openToolboxId = this._openToolboxId.asReadonly();
  public readonly scrollTrigger = this._scrollTrigger.asReadonly();

  public toggle(id: string): void {
    this._openToolboxId.update((current) => (current === id ? null : id));
  }

  public close(id: string): void {
    if (this._openToolboxId() === id) {
      this._openToolboxId.set(null);
    }
  }

  public isOpen(id: string): boolean {
    return this._openToolboxId() === id;
  }

  public triggerScrollToBottom(): void {
    this._scrollTrigger.update((v) => v + 1);
  }
}
